import { apiGet, apiPostForm } from './client';

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function getPublicSelectionRoster({ query, limit = 24, offset = 0 } = {}) {
  return apiGet(`/selection/participants${buildQuery({ query, limit, offset })}`, { auth: false });
}

export function importAdminSelectionRoster(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/admin/selection-roster/import', formData);
}
